import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import useShowcasePageScroll from "../hooks/useShowcasePageScroll";
import Context from "../context/Context";
import { useUserAuth } from "../context/UserAuthContext";
import axios from "axios";
import EntryView from "../Components/EntryView/EntryView";
import styles from "./styles/HomePageShowcase.module.css";
import { useLocation, useNavigate } from "react-router";
import { Link, createSearchParams } from "react-router-dom";
import LoadingFromCenter from "../Components/LoadingFromCenter/LoadingFromCenter";
import { isEmpty } from "lodash";
import bellicon from "../assests/bellicon.svg";
import user from "../assests/user.svg";
import govirallogoblack from "../assests/govirallogoblack.svg";
import hoeLogo from "../assests/hoeLogoBlack.png";

export default function HomePageShowcase() {
  const [loading, setLoading] = useState(true);
  const [viewMore, setViewMore] = useState(true);
  const [likeMapObjApi, setLikeMapObjApi] = useState({});
  const [newNotificationFound, setNewNotificationsFound] = useState(false);

  const [likeMap, setLikeMap] = useState(new Map());
  const {
    showcaseScrollPositionRef,
    userIdToken,
    verifyUser,
    showcasePageNumber,
    setShowcasePageNumber,
    setImageGalleryContents,
    buildType,
    isMobile,
  } = useContext(Context);
  const { currentUser, setPreviousLocation, searchParams } = useUserAuth();
  const token = userIdToken || currentUser?.accessToken;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!currentUser && isMobile) {
      navigate(`/signup`, {
        state: { previousLocation: "/" },
      });
    }
  });

  useEffect(() => {
    verifyUser();
  }, []);
  useEffect(() => {
    window.scrollTo(0, showcaseScrollPositionRef.current);
  }, []);
  // useEffect(() => {
  //   getLikedEntries();
  // }, []);
  useEffect(() => {
    const updatedLikeMap = new Map(likeMap);
    const likedEntryObject = likeMapObjApi;
    if (likedEntryObject) {
      Object?.entries(likedEntryObject)?.forEach(([key, value]) => {
        if (updatedLikeMap.has(key)) {
          const obj = { ...updatedLikeMap.get(key), ...value };

          updatedLikeMap.set(key, obj);
        } else {
          updatedLikeMap.set(key, value);
        }
      });

      setLikeMap(updatedLikeMap);
    }
  }, [likeMapObjApi]);
  const getLikedEntries = async () => {
    setLoading(true);
    try {
      let config = {
        method: "GET",
        url: `${process.env.REACT_APP_GET_SHOWCASE_ENTRIES_LIKE}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);
      setLikeMapObjApi(response?.data?.result);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  const { dataloading, error, imageGalleryContents, hasMore } =
    useShowcasePageScroll(
      showcasePageNumber,
      token,
      likeMap,
      setLikeMap,
      viewMore
    );
  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (dataloading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setShowcasePageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [dataloading, hasMore]
  );
  const handleLogin = () => {
    setImageGalleryContents([]);
    setPreviousLocation(window.location.pathname);
    navigate(
      {
        pathname: `/signup`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      {
        state: {
          previousLocation: `/`,
        },
      }
    );
  };
  const handleProfileNavigate = () => {
    setPreviousLocation(window.location.pathname);
    navigate(
      {
        pathname: `/profile`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      { state: { previousLocation: location?.pathname } }
    );
  };

  const handleNotificationNavigate = () => {
    setPreviousLocation(window.location.pathname);
    navigate({
      pathname: `/notification`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };
  return (
    <div className="widthController" style={{ backgroundColor: "#fff" }}>
      <div
        className={` w-[100%] py-[12px] px-[20px] flex items-center justify-between z-10 bg-white sticky top-0`}
      >
        <div className=" ">
          <img
            src={buildType == "highonevent" ? hoeLogo : govirallogoblack}
            alt=""
            className="h-[27px]"
          />
        </div>
        <>
          {currentUser ? (
            <div className="flex items-center gap-[13px]">
              <div className="icon-bg relative">
                <img
                  src={bellicon}
                  alt=""
                  className=" object-cover  overflow-hidden   cursor-pointer z-10"
                  onClick={handleNotificationNavigate}
                />
                {newNotificationFound && (
                  <div className="new-notification-indication absolute top-[2px] right-[2px]" />
                )}
              </div>

              <img
                src={currentUser?.photoURL ? currentUser?.photoURL : user}
                alt=""
                className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                onClick={handleProfileNavigate}
              />
            </div>
          ) : (
            <div className="flex gap-[16px]">
              <img
                src={user}
                alt=""
                className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                onClick={handleLogin}
              />
            </div>
          )}
        </>
      </div>
      <div>
        {imageGalleryContents?.map((obj, index) => (
          <div
            ref={
              index === imageGalleryContents?.length - 1 ? lastElementRef : null
            }
            className="w-full h-auto pb-[12px]"
            key={obj?.entryId}
          >
            <EntryView data={obj} likeMap={likeMap} />
            <div className="w-full bg-[#000] opacity-10 h-[1px] mt-[4px]" />
          </div>
        ))}
        {dataloading && (
          <div
            className={`w-full p-[20px] flex justify-center items-center ${
              isEmpty(imageGalleryContents) && "min-h-[100vh]"
            }`}
          >
            <LoadingFromCenter />
          </div>
        )}
        {!currentUser && (
          <div className={styles.signupBanner}>
            <h3>Sign in to View more</h3>
            <p>
              Sign in to see contest entries and videos from people who
              participated on exciting contests and discover other exciting
              contests & giveaways you'll love.
            </p>
            <button onClick={handleLogin}>Sign in</button>
          </div>
        )}
      </div>
    </div>
  );
}
